import React from "react";
import { FormattedMessage } from "react-intl";
import { cn } from "~/lib/utils";
import { Progress } from "./progress";

interface FreeTrialProgressBarProps {
  pagesUsed: number;
  freeTrialLimit: number;
  className?: string;
}

export const FreeTrialProgressBar: React.FC<FreeTrialProgressBarProps> = ({
  pagesUsed,
  freeTrialLimit,
  className,
}) => {
  const usagePercentage = Math.min((pagesUsed / freeTrialLimit) * 100, 100);

  const getProgressColor = (percentage: number) => {
    if (percentage < 70) return "bg-green-600";
    if (percentage < 90) return "bg-yellow-600";
    return "bg-red-600";
  };

  const progressColor = getProgressColor(usagePercentage);

  return (
    <div className={cn("flex items-center gap-2", className)}>
      <span className="text-xs font-medium text-muted-foreground whitespace-nowrap">
        <FormattedMessage
          id="freeTrialProgress.label"
          defaultMessage="Free Trial"
        />
      </span>
      <Progress
        value={usagePercentage}
        className="h-2 w-20"
        indicatorClassName={progressColor}
      />
      <span className="text-xs font-medium text-muted-foreground whitespace-nowrap">
        {pagesUsed.toLocaleString()} / {freeTrialLimit.toLocaleString()}
      </span>
    </div>
  );
};
